export const MERCURE_TOPIC = Object.freeze({
  ORDER_STATUS: 'preorder.order.payment-status',
})

export default MERCURE_TOPIC
